import merge from 'lodash/merge'
import units from '@/data/units.json'
import types from '@/data/types.json'
import { UNIT_STATUS } from '@/modules/useUnit'

export default {
  namespaced: true,
  state: () => ({
    units: [],
  }),
  mutations: {
    set (state, payload) {
      units.forEach(unit => {
        unit.type = types.find(type => type.name === unit.UnitType)
      })
      state.units = merge(units, payload)
    },
  },
  getters: {
    available (state) {
      return state.units.filter(unit => UNIT_STATUS.STATUS_AVAILABLE.includes(unit.UnitStatus))
    },
    sold (state) {
      return state.units.filter(unit => UNIT_STATUS.STATUS_SOLD.includes(unit.UnitStatus))
    },
    hold (state) {
      return state.units.filter(unit => UNIT_STATUS.STATUS_HOLD.includes(unit.UnitStatus))
    },
  },
}
